import { Resolution } from '../model';

interface ResolutionConfig {
  value: Resolution;
  label: string;
}
export const ResolutionConfigs: { [P in Resolution]: ResolutionConfig } = {
  [Resolution.FiveMinutes]: { value: Resolution.FiveMinutes, label: '5m' },
  [Resolution.Hour]: { value: Resolution.Hour, label: '1H' },
  [Resolution.SixHours]: { value: Resolution.SixHours, label: '6H' },
  [Resolution.Day]: { value: Resolution.Day, label: '1D' },
  [Resolution.Week]: { value: Resolution.Week, label: '1W' }
};

export const getResolutionConfig = (resolution: Resolution): ResolutionConfig => {
  if (!Object.keys(ResolutionConfigs).includes(resolution)) {
    throw new Error('Invalid resolution provided.');
  }

  return ResolutionConfigs[resolution];
}
